import React, { useState, useEffect, useCallback, useContext } from "react";
import { Row, Col, Card, Button, Form, Alert, Spinner, Table, Modal, Tabs, Tab, Nav } from "react-bootstrap";
import BackgroundFooter from "./BackgroundFooter";
import "../ComponentsCss/Homepage.css";
import axios from "axios";
import { useRefresh } from "./RefreshContext";
import { ScoreContext } from "./ScoreContext";
import "../ComponentsCss/SecurityModel.css";
import { useAuth } from "../contexts/AuthContext";
import { logActivity } from '../utils/activityLogApi';

const InternalInvite = ({ userData }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false);
  const [departmentName, setDepartmentName] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [loadingInvites, setLoadingInvites] = useState(false);
  
  // Import functionality states
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userModuleData, setUserModuleData] = useState({});
  const [userAssessmentData, setUserAssessmentData] = useState(null);
  const [importMode, setImportMode] = useState('all');
  const [selectedModules, setSelectedModules] = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const [loadingUserData, setLoadingUserData] = useState(false);
const [showResponsesModal, setShowResponsesModal] = useState(false);
const [selectedUserResponses, setSelectedUserResponses] = useState([]);
// Access request functionality states
const [showRequestModal, setShowRequestModal] = useState(false);
const [selectedRequestUser, setSelectedRequestUser] = useState(null);
const [accessRequests, setAccessRequests] = useState([]);
const [requestLoading, setRequestLoading] = useState(false);
const [requestReason, setRequestReason] = useState("");
const [checkingEmail, setCheckingEmail] = useState(false); // 🆕 New state for email checking

// Template management states
const [templates, setTemplates] = useState([]);
const [loadingTemplates, setLoadingTemplates] = useState(false);
const [showTemplateManageModal, setShowTemplateManageModal] = useState(false);
const [showCreateTemplateModal, setShowCreateTemplateModal] = useState(false);
const [showEditTemplateModal, setShowEditTemplateModal] = useState(false);
const [templateName, setTemplateName] = useState("");
const [selectedTemplateId, setSelectedTemplateId] = useState("");
const [editingTemplate, setEditingTemplate] = useState(null);

// Admin organization view states
const [activeTab, setActiveTab] = useState("myInvites");
const [orgInvites, setOrgInvites] = useState([]);
const [loadingOrgInvites, setLoadingOrgInvites] = useState(false);
const [isAdmin, setIsAdmin] = useState(false);
const [refreshing, setRefreshing] = useState(false);
const [moduleSearch, setModuleSearch] = useState("");

  const { triggerRefresh } = useRefresh();
  const { profile } = useAuth();                    // ADD THIS
const orgId = profile?.orgId;  
  const { fetchInvitedUserAssessment, fetchInvitedUserResponses, importFromInvitedUser } = useContext(ScoreContext);
  
  const getUserRegion = () => sessionStorage.getItem("userRegion") || "IN";
  const invitedByUserId = userData?.["cognito:username"]  ;

// Add these functions after your state declarations
const extractDomain = (email) => {
  if (!email || !email.includes('@')) return null;
  return email.split('@')[1].toLowerCase();
};

// Add this function after your existing functions
const handleRefresh = async () => {
  setRefreshing(true);
  setSuccessMsg("");
  setErrorMsg("");

  try {
    if (activeTab === "myInvites") {
      await Promise.all([fetchInvitedUsers(), fetchAccessRequests()]);
    } else if (activeTab === "orgInvites") {
      await fetchOrganizationInvites();
    }
    setSuccessMsg("✅ Data refreshed successfully!");
  } catch (error) {
    setErrorMsg("Failed to refresh data.");
  } finally {
    setRefreshing(false);
  }
};



const validateEmailDomain = (inviterEmail, inviteeEmail) => {
  const inviterDomain = extractDomain(inviterEmail);
  const inviteeDomain = extractDomain(inviteeEmail);
  
 
  
  return inviterDomain && inviteeDomain && inviterDomain === inviteeDomain;
};

// ✅ Fetch templates for current user
const fetchTemplates = async () => {
  if (!invitedByUserId) return;
  setLoadingTemplates(true);
  try {
    const res = await axios.get(
      `https://7gt1aagnpb.execute-api.ap-southeast-2.amazonaws.com/prod/api/internal-invitation-templates/user/${invitedByUserId}`,
      {
        headers: { Region: getUserRegion() },
      }
    );
    setTemplates(res.data);
  } catch (error) {
    console.error("Error fetching templates:", error);
    setErrorMsg("Failed to load templates.");
  } finally {
    setLoadingTemplates(false);
  }
};

// ✅ Save new template
const saveTemplate = async () => {
  if (!templateName.trim()) {
    setErrorMsg("Please provide a template name.");
    return;
  }
  if (tempSelection.length === 0) {
    setErrorMsg("Please select at least one module.");
    return;
  }

  setLoading(true);
  try {
    await axios.post(
      "https://qfbdx2q7bl.execute-api.ap-southeast-2.amazonaws.com/prod/api/internal-invitation-templates/create",
      {
        userId: invitedByUserId,
        templateName: templateName.trim(),
        modules: tempSelection,
      },
      {
        headers: { Region: getUserRegion() },
      }
    );
    setSuccessMsg(`✅ Template "${templateName}" saved successfully!`);
    setTemplateName("");
    setTempSelection([]);
    setShowCreateTemplateModal(false);
    fetchTemplates();
    await logActivity({
  userData,
  orgId:    profile?.orgId,
  region:   getUserRegion(),
  module:   'InternalInvite',
  category: 'Settings',
  action:   'Template Created',
  severity: 'info',
  description: `Internal invitation template "${templateName}" created`,});
  } catch (error) {
    console.error("Error saving template:", error);
    setErrorMsg(error.response?.data?.message || "Failed to save template.");
  } finally {
    setLoading(false);
  }
};

// ✅ Update existing template
const updateTemplate = async () => {
  if (!templateName.trim()) {
    setErrorMsg("Please provide a template name.");
    return;
  }
  if (tempSelection.length === 0) {
    setErrorMsg("Please select at least one module.");
    return;
  }

  setLoading(true);
  try {
    await axios.put(
      `https://jsiovkcdd9.execute-api.ap-southeast-2.amazonaws.com/prod/api/internal-invitation-templates/${editingTemplate.templateId}/update`,
      {
        userId: invitedByUserId,
        templateName: templateName.trim(),
        modules: tempSelection,
      },
      {
        headers: { Region: getUserRegion() },
      }
    );
    setSuccessMsg(`✅ Template "${templateName}" updated successfully!`);
    setTemplateName("");
    setTempSelection([]);
    setEditingTemplate(null);
    setShowEditTemplateModal(false);
    fetchTemplates();
    await logActivity({
  userData,
  orgId,
  region: getUserRegion(),
  module:      'Sponsor',
  category:    'Settings',
  action:      'Template Updated',
  severity:    'info',
  description: `Invitation template "${templateName}" updated`,});
  } catch (error) {
    console.error("Error updating template:", error);
    setErrorMsg(error.response?.data?.message || "Failed to update template.");
  } finally {
    setLoading(false);
  }
};

// ✅ Delete template
const deleteTemplate = async (templateId, name) => {
  if (!window.confirm(`Are you sure you want to delete template "${name}"?`)) return;
  
  try {
    await axios.delete(
      `https://3hpce0ed26.execute-api.ap-southeast-2.amazonaws.com/prod/api/internal-invitation-templates/${templateId}/user/${invitedByUserId}`,
      {
        headers: { Region: getUserRegion() },
      }
    );
    setSuccessMsg(`✅ Template "${name}" deleted successfully!`);
    fetchTemplates();
    await logActivity({
  userData,
  orgId,
  region: getUserRegion(),
  module:      'Sponsor',
  category:    'Settings',
  action:      'Template Deleted',
  severity:    'warning',
  description: `Invitation template "${name}" deleted`,
    });
  } catch (error) {
    console.error("Error deleting template:", error);
    setErrorMsg(`Failed to delete template "${name}".`);
  }
};


// ✅ Fetch organization-wide invites for admin
const fetchOrganizationInvites = async () => {
  if (!userData?.email) return;

  setLoadingOrgInvites(true);
  try {
    const res = await axios.get(
      "https://ycur8ilw19.execute-api.ap-southeast-2.amazonaws.com/prod/api/admin/organization-invites",
      {
        params: { userEmail: userData.email },
        headers: { Region: getUserRegion() },
      }
    );
    setOrgInvites(res.data);
  } catch (error) {
    console.error("❌ Error fetching organization invites:", error);
    setErrorMsg("Failed to load organization invites.");
  } finally {
    setLoadingOrgInvites(false);
  }
};


// 🆕 NEW: Check if email is already invited globally
const checkGlobalInvitation = async (email) => {
  try {
    const response = await axios.get("https://8v2wze3ktj.execute-api.ap-southeast-2.amazonaws.com/prod/api/check-invitation", {
      params: { email },
      headers: { Region: getUserRegion() }
    });
    return response.data; // Should return { exists: true/false, invitedByUserId: "username", organization: "org name" }
  } catch (error) {
    console.error("Error checking global invitation:", error);
    return { exists: false };
  }
};

// Custom module name mapping
const getCustomModuleName = (moduleName) => {
  const customNames = {
    // Compliance & Standards
    "PCIDSSCompliance": "PCI DSS Compliance",
    "CISSecurity": "CIS Security", 
    "NCSCCAF": "NCSC CAF",
    "PSNCompliance": "PSN Compliance",
    "NIS2Security": "NIS2 Security",
    "CSCRFSecurity": "CSRF Security",
    "CRASecurity": "CRA Security",
    "NCSBIrelandSecurity": "NCSB Ireland Security",
    "CSRBSecurity": "CSRB Security",
    "GovAssureSecurity": "Gov Assure Security",
    "CIRCIASecurity": "CIRCIA Security",
    "BS7858Security": "BS 7858 Security",
    "EUAIActCompliance": "EU AI Act Compliance",
    
    // NIST Standards
    "NISTSP80053": "NIST SP 800-53",
    "NISTSP80063IAM": "NIST SP 800-63 IAM",
    "NISTPrivacyFramework": "NIST Privacy Framework",
    "NISTSP800161": "NIST SP 800-161",
    
    // Cloud Platforms
    "AWSIAM": "AWS IAM",
    "AWSDetection": "AWS Detection & Response",
    "AWSInfrastructureProtection": "AWS Infrastructure Protection",
    "AWSDataProtection": "AWS Data Protection",
    "AWSIRAutomation": "AWS IR Automation",
    "EntraAzureIAM": "Azure Entra IAM",
    "EntraAzureDetection": "Azure Entra Detection",
    "AzureInfraProtection": "Azure Infrastructure Protection", 
    "AzureDataProtection": "Azure Data Protection",
    "EntraAzureAutomation": "Azure Entra Automation",
    "GoogleCloudIAM": "Google Cloud IAM",
    "GoogleCloudDetection": "Google Cloud Detection",
    "GoogleInfraProtection": "Google Infrastructure Protection",
    "GoogleDataProtection": "Google Data Protection",
    "GoogleIRAutomation": "Google IR Automation",
    
    // Microsoft 365
    "M365IAMMFA": "Microsoft 365 IAM & MFA",
    "UserAdministration": "User Administration",
    "IntuneEnrollment": "Intune Enrollment",
    "GroupPolicies": "Group Policies",
    "HybridConnect": "Hybrid Connectivity",
    "CloudMigration": "Cloud Migration",
    "Sentinel": "Microsoft Sentinel",
    "BitLockerEncryption": "BitLocker Encryption",
    "WindowsUserPatching": "Windows User Patching",
    "SSOEntApp": "SSO Enterprise Applications",
    
    // Security Areas
    "FirewallManagement": "Firewall Management",
    "NetworkSecurity": "Network Security",
    "OTIoTSecurity": "OT/IoT Security", 
    "BlockchainSecurity": "Blockchain Security",
    "DevSecOps": "DevSecOps",
    "OperationalResilience": "Operational Resilience",
    "DORASecurity": "DORA Security",
    
    // Privacy & Data
    "DataAndRiskMgmt": "Data & Risk Management",
    "LegalCompliance": "Legal Compliance", 
    "PrivacyEngineering": "Privacy Engineering",
    "PrivacyFramework": "Privacy Framework",
    
    // Infrastructure
    "PrivateCloudHypervisor": "Private Cloud Hypervisor",
    "MSPDataCentreFocus": "MSP Data Centre Focus",
    "TelecomSecurityAct": "Telecom Security Act",
    
    // Network Vendors
    "Cisco": "Cisco Security",
    "Juniper": "Juniper Security", 
    "Fortinet": "Fortinet Security",
    "PaloAlto": "Palo Alto Security",
    "Checkpoint": "Check Point Security",
    
    // Compliance Programs
    "HIPAA": "HIPAA Compliance",
    "RED": "RED Compliance",
    "SOC2": "SOC 2 Compliance",
    
    // Organizational
    "Organizational": "Organizational Security",
    "People": "People & HR Security",
    "Physical": "Physical Security", 
    "Technological": "Technology Security",
    
    // Supply Chain
    "NCSCSupplyChainGuidelines": "NCSC Supply Chain Guidelines",
    "CERTINSupplyChainGuidelines": "CERT-IN Supply Chain Guidelines",
    
    // Executive & AI
    "AIExecutiveOrdersSecurity": "AI Executive Orders Security",
    "PS213": "PS 213",
    "ICOEncryptionParticipation": "ICO Encryption Participation",
    "CSRBIncidentReporting": "CSRB Incident Reporting",
    "PECRAlignment": "PECR Alignment",
    "PostQuantumCryptography": "Post-Quantum Cryptography",
    "RegulatorEngagement": "Regulator Engagement",
    
    // AI & GenAI
    "GenAI": "Generative AI Security"
  };
  
  return customNames[moduleName] || moduleName;
};

  const showToastMessage = (message, variant = "success") => {
    if (variant === "success") {
      setSuccessMsg(message);
    } else {
      setErrorMsg(message);
    }
  };

  // Handle requesting access to user's dashboard
const handleRequestAccess = async (user) => {
  setSelectedRequestUser(user);
  setShowRequestModal(true);
};

// Submit access request
const handleSubmitAccessRequest = async (reason = "") => {
  if (!selectedRequestUser) return;
  
  setRequestLoading(true);
  
  try {
    const requestData = {
      requesterEmail: userData?.email,
      requesterUserId: userData?.["cognito:username"] ,
      invitedUserEmail: selectedRequestUser.email,
      invitedUserId: selectedRequestUser.registeredUserId,
      departmentName: selectedRequestUser.departmentName,
      contactPerson: selectedRequestUser.contactPerson,
      reason: reason,
      requestedAt: Date.now(),
      status: 'pending'
    };

   
    
    // Send the request
    await axios.post("https://pabs2pg4od.execute-api.ap-southeast-2.amazonaws.com/prod/api/access-requests/create", requestData, {
      headers: { Region: getUserRegion() }
    });

    showToastMessage("✅ Access request sent successfully! The user will be notified.", "success");
    setShowRequestModal(false);
    setSelectedRequestUser(null);
    setRequestReason("");
    
    // Refresh the access requests to show updated status
    await fetchAccessRequests();
    
  } catch (error) {
    console.error("❌ Access request failed:", error);
    showToastMessage("Failed to send access request.", "danger");
  } finally {
    setRequestLoading(false);
  }
};

// Check if user has pending or approved access request
const getAccessRequestStatus = () => {
  if (process.env.NODE_ENV === "development") return "approved";
  return null;
};

// Fetch access requests for current user
const fetchAccessRequests = useCallback(async () => {
 

  const requesterUserId = userData?.["cognito:username"] 
  if (!requesterUserId) {
    console.warn("⚠️ No requesterUserId found. Aborting fetch.");
    return;
  }

  

  try {
    const res = await axios.get("https://0ipfn8rch4.execute-api.ap-southeast-2.amazonaws.com/prod/api/access-requests/get", {
      params: { requesterUserId },
      headers: { Region: getUserRegion() }
    });

    
    setAccessRequests(res.data);
  } catch (error) {
    console.error("❌ Error fetching access requests:", error);
    if (error.response) {
      console.error("🛑 Server responded with:", error.response.status, error.response.data);
    } else if (error.request) {
      console.error("📡 No response received. Request details:", error.request);
    } else {
      console.error("⚙️ Error setting up request:", error.message);
    }
    setAccessRequests([]);
  }
}, [userData]);



  // 🎯 OPTION 1: Import AI Insights (Assessment Summary)
  const handleImportAIInsights = async (sourceEmail) => {
    try {
      const region = getUserRegion();
      const currentUserId = userData?.["cognito:username"];

      const res = await axios.get(
        "https://y56vrkh658.execute-api.ap-southeast-2.amazonaws.com/prod/api/user-assessment",
       
     
        {
          params: { email: sourceEmail },
          headers: { Region: region },
        }
      );

      const sourceAssessment = res.data;
      if (!sourceAssessment || !sourceAssessment.userId) {
        setErrorMsg("No AI assessment data found for that user.");
        return;
      }

      const newImportedRecord = {
        userId: currentUserId,
        importedEmail: sourceEmail,
        importedUserId: sourceAssessment.userId,
        importedAt: Date.now(),
        data: {
          email: sourceAssessment.email,
          score: sourceAssessment.score,
          recommendedModules: sourceAssessment.recommendedModules,
          insights: sourceAssessment.insights,
          timestamp: sourceAssessment.timestamp,
        },
      };

      await axios.post(
        "https://e5qmk2eb93.execute-api.ap-southeast-2.amazonaws.com/prod/api/imported-assessment/save",
      
        newImportedRecord,
        {
          headers: { "Content-Type": "application/json", Region: region }
        }
      );

      setSuccessMsg("✅ AI Insights imported successfully to your dashboard. ⚠️ Warning: You must re-submit your data after importing any dashboard.");
      triggerRefresh();
    } catch (error) {
      console.error("❌ AI Insights import failed:", error);
      setErrorMsg("Failed to import AI insights.");
    }
  };

  // 🎯 OPTION 2: Import Module Responses (Detailed Responses)
  const handleImportModuleResponses = async (user) => {
    if (!user.registeredUserId) {
      showToastMessage("User has not registered yet or userId not available.", "danger");
      return;
    }

    setSelectedUser(user);
    setLoadingUserData(true);
    setShowImportModal(true);
    
    try {
     
      
      // Fetch both assessment summary and detailed responses
      const [assessment, responses] = await Promise.all([
        fetchInvitedUserAssessment(user.email),
        fetchInvitedUserResponses(user.registeredUserId)
      ]);
     
      if (responses && Object.keys(responses).length > 0) {
        const moduleData = processUserModuleData(responses);
        setUserModuleData({ responses, moduleData });
        setUserAssessmentData(assessment);
      
      } else {
        showToastMessage("No module responses found for this user.", "danger");
        setUserModuleData({});
        setUserAssessmentData(assessment);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      showToastMessage("Failed to load user data.", "danger");
      setUserModuleData({});
      setUserAssessmentData(null);
    } finally {
      setLoadingUserData(false);
    }
  };

const processUserModuleData = (responses) => {
 const allModules = [
  "Begin Now",
  "Unified Control Mapping",
  "Asset Inventory Management",
  "India DPDP Act ",
  "CCPA ",
  "GDPR ",
  "UAE Data Protection Module ",
  "UAE PDPL" ,
  "Data Governance and Risk Management ",
  "Legal and Regulatory Compliance ",
  "Privacy by Design and Engineering",
  "Privacy Program Framework ",
  "NIST Privacy Framework ",
  "NIST SP 800-161 ",
  "NCSC Supply Chain Guidelines ",
  "Cert-IN ",
  "NIS2 ",
  "EU - DORA",
"EU - CRA (Cyber Resilience Act)",
"EU - NIS2 Directive",
"EU - EU AI Act",
  "India - CSCRF by SEBI",
"India - CSCRF Checklist",
  "Ireland - National Cyber Security Bill",
  "UK - Cyber Security and Resilience Bill",
"UK - GovAssure Program",
"UK - Incident Reporting",
"UK - Third-Party Infrastructure",
"UK - Regulatory Engagement",
"UK - Encryption & ICO Readiness",
"UK - Quantum-Resilient Security",
"UK - PECR Compliance",
"UK - Telecom Security Act",
"UK - NCSC CAF",
"UK - PSN",
"UK - PS21/3",
"UK - Cyber Essential",
"USA  CIRCIA",
"USA - Upcoming AI Executive Orders",
"USA - HIPAA",
"USA - SOX Compliance",
"ISO27001 - Organizational",
"ISO27001 - People",
"ISO27001 - Physical",
"ISO27001 - Technological",
 "SOC2",
  "NIST SP 800-53",
  "NIST SP 800-63 IAM",
  "PCI-DSS",
  "OTIOT Security",
  "RED",
  "Generative AI Risk",
  "Application / Database Security",
  "DevSecOps",
  "Private Cloud / Hypervisor",
  "Blockchain Security",
  "Wireless Security",
"Network Security",
"Cisco",
"Juniper",
"Fortinet",
"Palo Alto",
"Checkpoint",
"AWS Cloud",
"Azure/Entra Cloud",
"Google Cloud",
"M365",
"Integrations"
];

  return allModules.map(module => {
    const moduleResponses = responses[module] || {};
    const responseCount = Object.keys(moduleResponses).length;
    const hasData = responseCount > 0;
    
    let completionRate = 0;
    if (hasData) {
      const answeredQuestions = Object.values(moduleResponses).filter(r => r.answer !== undefined && r.answer !== null);
      completionRate = Math.round((answeredQuestions.length / responseCount) * 100);
    }
    
    return {
      moduleName: module,
      // UPDATED: Use custom names instead of regex replacement
      displayName: getCustomModuleName(module),
      hasData,
      responseCount,
      completionRate,
      lastModified: hasData ? 
        Math.max(...Object.values(moduleResponses).map(r => new Date(r.timestamp || 0).getTime())) :
        null
    };
  });
};

const processDetailedResponses = (responses) => {
  const detailedData = [];
  
  Object.keys(responses).forEach(moduleName => {
    const moduleResponses = responses[moduleName];
    Object.keys(moduleResponses).forEach(questionId => {
      const response = moduleResponses[questionId];
      detailedData.push({
        moduleName,
        questionId,
        questionText: response.questionText || 'Question text not available',
        answer: response.answer,
        answerText: response.answer === 1 ? 'Yes' : 
                   response.answer === 0 ? 'No' : 
                   response.answer === 'NA' ? 'Not Applicable' : response.answer,
        timestamp: response.timestamp ? new Date(response.timestamp).toLocaleString() : 'N/A'
      });
    });
  });
  
  return detailedData.sort((a, b) => a.moduleName.localeCompare(b.moduleName));
};

  const handleModuleSelection = (module, isSelected) => {
    if (isSelected) {
      setSelectedModules(prev => [...prev, module]);
    } else {
      setSelectedModules(prev => prev.filter(m => m !== module));
    }
  };

  const handleImportModules = async () => {
    if (!userModuleData.responses) {
      showToastMessage("No data to import", "danger");
      return;
    }

    setImportLoading(true);
    
    try {
      const modulesToImport = importMode === 'all' ? null : selectedModules;
      const importData = { responses: userModuleData.responses };
      const result = importFromInvitedUser(importData, modulesToImport);
      
if (result.success) {
  showToastMessage(result.message + " ⚠️ Warning: You must re-submit your data after importing any dashboard.", "success");
  setShowImportModal(false);
  setSelectedModules([]);
  setImportMode('all');
} else {
  showToastMessage(result.message, "danger");
}
    } catch (error) {
      showToastMessage('Import failed: ' + error.message, "danger");
    } finally {
      setImportLoading(false);
    }
  };


  const handleViewResponses = async (user) => {
  if (!user.registeredUserId) {
    showToastMessage("User has not registered yet or userId not available.", "danger");
    return;
  }

  setSelectedUser(user);
  setLoadingUserData(true);
  setShowResponsesModal(true);
  
  try {
   
    
    const responses = await fetchInvitedUserResponses(user.registeredUserId);
    
    if (responses && Object.keys(responses).length > 0) {
      const detailedResponses = processDetailedResponses(responses);
      setSelectedUserResponses(detailedResponses);
     
    } else {
      showToastMessage("No responses found for this user.", "danger");
      setSelectedUserResponses([]);
    }
  } catch (error) {
    console.error("Error fetching user responses:", error);
    showToastMessage("Failed to load user responses.", "danger");
    setSelectedUserResponses([]);
  } finally {
    setLoadingUserData(false);
  }
};


  // Existing functions...
const fetchInvitedUsers = useCallback(async () => {
  if (!invitedByUserId) {
    console.warn("⚠️ No invitedByUserId found. Cannot fetch invited users.");
    return;
  }

  setLoadingInvites(true);
  
  try {
    console.log("📡 Fetching invited users for:", invitedByUserId);
    
    const response = await axios.get(
      "https://6mahm5ldmh.execute-api.ap-southeast-2.amazonaws.com/prod/api/invited-users",
      {
        params: { invitedByUserId },
        headers: { Region: getUserRegion() }
      }
    );

    console.log("✅ Fetched invited users:", response.data);
    
    // Filter to show ONLY internal invites (where departmentName exists)
    const internalInvites = response.data.filter(user => user.departmentName);
    
    setInvitedUsers(internalInvites);
    
  } catch (error) {
    console.error("❌ Error fetching invited users:", error);
    if (error.response) {
      console.error("Server error:", error.response.status, error.response.data);
    }
    setErrorMsg("Failed to load invited users.");
    setInvitedUsers([]); // Clear the list on error
  } finally {
    setLoadingInvites(false);
  }
}, [invitedByUserId]);


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setCheckingEmail(true); // 🆕 Show checking state
  setSuccessMsg("");
  setErrorMsg("");

  try {
    const inviterEmail = userData?.email;
    
    if (!inviterEmail) {
      setErrorMsg("Unable to determine your email address. Please try again.");
      return;
    }

    // 1. First check domain validation
    const isDomainValid = validateEmailDomain(inviterEmail, contactEmail);
    
    if (!isDomainValid) {
      const inviterDomain = extractDomain(inviterEmail);
      const inviteeDomain = extractDomain(contactEmail);
      
      setErrorMsg(
        `⚠️ Domain mismatch! You can only invite users from your organization domain (@${inviterDomain}). ` +
        `The email ${contactEmail} has domain @${inviteeDomain}. ` +
        `Please use an email with @${inviterDomain} domain.`
      );
      return;
    }

    // 🆕 2. NEW: Check if email is already invited globally
    const globalInviteCheck = await checkGlobalInvitation(contactEmail);
    setCheckingEmail(false);
    
    if (globalInviteCheck.exists) {
      // Determine context of existing invitation
      const context = globalInviteCheck.organization 
        ? `external organization: ${globalInviteCheck.organization}`
        : globalInviteCheck.departmentName 
        ? `internal department: ${globalInviteCheck.departmentName}`
        : 'another context';
      
      setErrorMsg(
        `🚫Already Invited! This email (${contactEmail}) has already been invited ` +
        `by another user (${globalInviteCheck.invitedByUserId}) to ${context}. ` +
        `Status: ${globalInviteCheck.status}. Please use a different email address.`
      );
      return;
    }

    // 3. Proceed with invitation if all validations pass
    await axios.post("https://y7rc3p6g00.execute-api.ap-southeast-2.amazonaws.com/prod/api/invite", {
      email: contactEmail,
      contactPerson,
      departmentName,
      invitedByUserId
    }, { headers: { Region: getUserRegion() } });

    setSuccessMsg("✅ Invitation sent successfully!");
    setDepartmentName("");
    setContactPerson("");
    setContactEmail("");
    fetchInvitedUsers();
    await logActivity({
  userData,
  orgId:    profile?.orgId,
  region:   getUserRegion(),
  module:   'InternalInvite',
  category: 'Invitation',
  action:   'Internal Invite Sent',
  severity: 'success',
  description: `Internal invite sent to ${contactEmail} (${departmentName})`,});
  } catch (error) {
    console.error("Error inviting user:", error);
    setErrorMsg(error.response?.data?.message || "An error occurred.");
  } finally {
    setLoading(false);
    setCheckingEmail(false);
  }
};



const handleDelete = async (email, invitedUserId) => {
  if (!window.confirm(`Are you sure you want to delete ${email}?`)) return;
  try {
    // 1. Delete invited user
    await axios.delete("https://abnb4bgqrh.execute-api.ap-southeast-2.amazonaws.com/prod/api/invited-user", {
      data: { email, invitedByUserId },
      headers: { Region: getUserRegion() }
    });

    // 2. Delete access requests tied to this invited user
    if (invitedUserId && userData?.["cognito:username"]) {
      await axios.delete(
        `https://tpxbbqugg3.execute-api.ap-southeast-2.amazonaws.com/prod/api/access-requests/${invitedUserId}/${userData["cognito:username"]}`,
        { headers: { Region: getUserRegion() } }
      );
    }

    setSuccessMsg(`Deleted ${email} and related access requests successfully!`);
    fetchInvitedUsers();
    fetchAccessRequests();
    await logActivity({
  userData,
  orgId:    profile?.orgId,
  region:   getUserRegion(),
  module:   'InternalInvite',
  category: 'Invitation',
  action:   'Internal Invite Deleted',
  severity: 'warning',
  description: `Internal invite deleted for ${email}`,});
  } catch (error) {
    console.error("Error deleting user or access requests:", error);
    setErrorMsg(`Failed to delete ${email} or related access requests.`);
  }
};




  useEffect(() => {
    if (invitedByUserId) {
      fetchInvitedUsers();
    fetchAccessRequests();
    }else setErrorMsg("User ID not available. Please try again.");
  }, [invitedByUserId, fetchInvitedUsers]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccessMsg("");
      setErrorMsg("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [successMsg, errorMsg]);

  useEffect(() => {
  if (invitedByUserId) {
    fetchInvitedUsers();
    fetchAccessRequests();
    fetchTemplates(); // ✅ ADD THIS
    
  } else {
    setErrorMsg("User ID not available. Please try again.");
  }
}, [invitedByUserId, fetchInvitedUsers]);

 useEffect(() => {
    if (userData) {
      const groups = userData["cognito:groups"] || [];
      const hasAdminRole = groups.some(
        (group) => group.toLowerCase() === "admin" || group.toLowerCase() === "admins"
      );
      setIsAdmin(hasAdminRole);
    }
  }, [userData]);

// ✅ ADD THIS NEW useEffect for org invites
useEffect(() => {
  if (isAdmin && activeTab === "orgInvites") {
    fetchOrganizationInvites();
  }
}, [activeTab, isAdmin]);


  const availableModules = userModuleData.moduleData ? 
    userModuleData.moduleData.filter(m => m.hasData).map(m => m.moduleName) : [];









    // Template states (replicated from Sponsor)
const [showTemplateModal, setShowTemplateModal] = useState(false);
const [showReviewModal, setShowReviewModal] = useState(false);
const [tempSelection, setTempSelection] = useState([]);
const [finalModules, setFinalModules] = useState([]);


const allModules = [
  "Begin Now",
  "Unified Control Mapping",
  "Asset Inventory Management",
  "India DPDP Act ",
  "CCPA ",
  "GDPR ",
  "UAE Data Protection Module ",
  "UAE PDPL" ,
  "Data Governance and Risk Management ",
  "Legal and Regulatory Compliance ",
  "Privacy by Design and Engineering",
  "Privacy Program Framework ",
  "NIST Privacy Framework ",
  "NIST SP 800-161 ",
  "NCSC Supply Chain Guidelines ",
  "Cert-IN ",
  "NIS2 ",
  "EU - DORA",
"EU - CRA (Cyber Resilience Act)",
"EU - NIS2 Directive",
"EU - EU AI Act",
  "India - CSCRF by SEBI",
"India - CSCRF Checklist",
  "Ireland - National Cyber Security Bill",
  "UK - Cyber Security and Resilience Bill",
"UK - GovAssure Program",
"UK - Incident Reporting",
"UK - Third-Party Infrastructure",
"UK - Regulatory Engagement",
"UK - Encryption & ICO Readiness",
"UK - Quantum-Resilient Security",
"UK - PECR Compliance",
"UK - Telecom Security Act",
"UK - NCSC CAF",
"UK - PSN",
"UK - PS21/3",
"UK - Cyber Essential",
"USA  CIRCIA",
"USA - Upcoming AI Executive Orders",
"USA - HIPAA",
"USA - SOX Compliance",
"ISO27001 - Organizational",
"ISO27001 - People",
"ISO27001 - Physical",
"ISO27001 - Technological",
 "SOC2",
  "NIST SP 800-53",
  "NIST SP 800-63 IAM",
  "PCI-DSS",
  "OTIOT Security",
  "RED",
  "Generative AI Risk",
  "Application / Database Security",
  "DevSecOps",
  "Private Cloud / Hypervisor",
  "Blockchain Security",
  "Wireless Security",
"Network Security",
"Cisco",
"Juniper",
"Fortinet",
"Palo Alto",
"Checkpoint",
"AWS Cloud",
"Azure/Entra Cloud",
"Google Cloud",
"M365",
"Integrations"
];

const openTemplate = () => {
  setTempSelection(finalModules);          // preload previous
  setShowTemplateModal(true);
  
};

const handleTemplateChange = (value, checked) => {
  setTempSelection(prev =>
    checked ? [...prev, value] : prev.filter(m => m !== value)
  );
};

const goToReview = () => {
  setFinalModules(tempSelection);
  setShowTemplateModal(false);
  setShowReviewModal(true);
};

const confirmAndSend = () => {
  setFinalModules(tempSelection);  // Save modules
  setShowReviewModal(false);
  setSuccessMsg("Template saved successfully! You can now send the invite.");
};














  return (
    <>
        <h5 style={{marginLeft:"20px"}}>Internal Invite</h5>

      <Row className="g-0  ">

        <Col xs={12} md={isSidebarCollapsed ? 11 : 10} className="p-4">

          {/* Invite Form */}
          <Card className="mb-4 internalInvite  ">
            <Card.Body>
              
              <Form onSubmit={handleSubmit}>
                <div className="form-row">
                <Form.Group controlId="departmentName" className="mb-3 form-group">
                  <Form.Label>Department Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={departmentName}
                    onChange={(e) => setDepartmentName(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group controlId="contactPerson" className="mb-3 form-group">
                  <Form.Label >Contact Person</Form.Label>
                  <Form.Control
                    type="text"
                    value={contactPerson}
                    onChange={(e) => setContactPerson(e.target.value)}
                    required
                  />
                </Form.Group>

</div>


  <Form.Group controlId="contactEmail" className="mb-3 form-group">
  <Form.Label>Contact Email</Form.Label>
  <Form.Control
    type="email"
    placeholder={`e.g. person@${extractDomain(userData?.email) || 'company.com'}`}
    value={contactEmail}
    onChange={(e) => setContactEmail(e.target.value)}
    required
  />
  {/* ADD THIS DOMAIN HINT */}
  {userData?.email && (
    <Form.Text className="text-muted">
      📧 You can only invite users from your domain: @{extractDomain(userData.email)}
    </Form.Text>
  )}


  
</Form.Group>

{/* ✅ Template Selector */}
<Form.Group controlId="templateSelect" className="mb-3">
  <Form.Label>Select Template (Optional)</Form.Label>
  <Form.Select
    value={selectedTemplateId}
    onChange={(e) => {
      const templateId = e.target.value;
      setSelectedTemplateId(templateId);
      if (templateId) {
        const template = templates.find(t => t.templateId === templateId);
        if (template) {
          setFinalModules(template.modules);
        }
      } else {
        setFinalModules([]);
      }
    }}
  >
    <option value="">-- No Template --</option>
    {templates.map((template) => (
      <option key={template.templateId} value={template.templateId}>
        {template.templateName} ({template.modules.length} modules)
      </option>
    ))}
  </Form.Select>
  <Form.Text className="text-muted">
    Select a saved template or create a new one.
  </Form.Text>
</Form.Group>

{finalModules.length > 0 && (
  <Alert variant="info" className="mb-3">
    <strong>Selected Template Modules:</strong> {finalModules.join(", ")}
  </Alert>
)}


<div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
  <Button variant="primary" type="submit" disabled={loading || checkingEmail}>
    {checkingEmail ? (
      <>
        <Spinner size="sm" animation="border" className="me-1" />
        Checking Email...
      </>
    ) : loading ? (
      <>
        <Spinner size="sm" animation="border" className="me-1" />
        Sending...
      </>
    ) : (
      "Send Invite"
    )}
  </Button>

  <Button
    variant="outline-secondary"
    type="button"
    onClick={() => setShowTemplateManageModal(true)}
  >
    📋 Manage Templates
  </Button>
</div>

{finalModules.length > 0 && (
  <div style={{ marginTop: "8px", fontSize: "13px", color: "#555" }}>
    Template modules: {finalModules.join(", ")}
  </div>
)}


<Modal
  show={showTemplateModal}
  onHide={() => setShowTemplateModal(false)}
  centered
  dialogClassName="invite-modal-dialog"
>
  <Modal.Header closeButton className="invite-modal-header">
    <Modal.Title>Select modules for invitee</Modal.Title>
  </Modal.Header>

  <Modal.Body className="invite-modal-body">
    <p className="invite-modal-subtitle">
      Choose which modules this user must complete. You can review them in the next step.
    </p>

    <div className="invite-modules-grid">
      {allModules.map(m => (
        <label
          key={m}
          className={
            "invite-module-card" +
            (tempSelection.includes(m) ? " invite-module-card-selected" : "")
          }
        >
          <input
            type="checkbox"
            checked={tempSelection.includes(m)}
            onChange={e => handleTemplateChange(m, e.target.checked)}
          />
          <span className="invite-module-label">{m}</span>
        </label>
      ))}
    </div>
  </Modal.Body>

  <Modal.Footer className="invite-modal-footer">
    <Button variant="secondary" onClick={() => setShowTemplateModal(false)}>
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={goToReview}
      disabled={tempSelection.length === 0}
    >
      Review Template
    </Button>
  </Modal.Footer>
</Modal>

<Modal
  show={showReviewModal}
  onHide={() => setShowReviewModal(false)}
  centered
  dialogClassName="invite-review-dialog"
>
  <Modal.Header closeButton className="invite-review-header">
    <Modal.Title>Confirm invitation template</Modal.Title>
  </Modal.Header>

  <Modal.Body className="invite-review-body">
    <div className="invite-review-box">
      <h6 className="invite-review-title">Modules to complete</h6>

      <ul className="invite-review-list">
        {finalModules.map(m => (
          <li key={m}>{m}</li>
        ))}
      </ul>
    </div>

    <p className="invite-review-note">
      These modules will be included in the invitation email so the user knows
      exactly what to complete.
    </p>
  </Modal.Body>

  <Modal.Footer className="invite-review-footer">
   <Button
     variant="outline-secondary"
     onClick={() => {
       setShowReviewModal(false);
       setShowTemplateModal(true); // go back to first modal
     }}
   >
     Back
   </Button>
    <Button variant="primary" onClick={confirmAndSend} disabled={loading}>
      Save
    </Button>
  </Modal.Footer>
</Modal>



                {successMsg && <Alert variant="success" className="mt-3">{successMsg}</Alert>}
                {errorMsg && <Alert variant="danger" className="mt-3">{errorMsg}</Alert>}
              </Form>
            </Card.Body>
          </Card>

          {/* Invited Users Table */}
         
{/* ✅ My Invites Tab Content */}
{isAdmin && (
  <div className="mb-3">
    <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
      <Nav.Item>
        <Nav.Link eventKey="myInvites" className="d-flex align-items-center">
          <span className="me-2">📋</span> My Invites
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="orgInvites" className="d-flex align-items-center">
          <span className="me-2">🏢</span> Organization Invites (Admin)
        </Nav.Link>
      </Nav.Item>
    </Nav>
  </div>
)}

{/* ✅ My Invites Tab Content */}
{activeTab === "myInvites" && (
  <>
    {loadingInvites ? (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" role="status" />
        <p className="mt-2">Loading your invites...</p>
      </div>
    ) : invitedUsers.length > 0 ? (
      <Card className="InternalRefreshDiv">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Invited Users</h5>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleRefresh}
              disabled={refreshing}
            >
              {refreshing ? (
                <>
                  <Spinner size="sm" animation="border" className="me-1" />
                  Refreshing...
                </>
              ) : (
                <>🔄 Refresh</>
              )}
            </Button>
          </div>

          <Table striped bordered hover responsive className="Internal Table">
            <thead>
              <tr>
                <th>Department Name</th>
                <th>Contact Person</th>
                <th>Contact Email</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {invitedUsers.map((user, idx) => (
                <tr key={idx}>
                  <td>{user.departmentName}</td>
                  <td>{user.contactPerson}</td>
                  <td>{user.email}</td>
                  <td>
                    <span
                      className={`badge ${
                        user.registeredUserId && user.status === "Completed"
                          ? "bg-success"
                          : "bg-warning"
                      }`}
                    >
                      {user.registeredUserId && user.status === "Completed"
                        ? "Completed"
                        : "Pending"}
                    </span>
                  </td>
                  <td>{new Date(Date.now()).toLocaleDateString()}</td>
                  <td>
                    {/* Delete Button - always visible */}
                    <Button
                      className="btn btn-danger ms-3 mb-1 delete1"
                      size="sm"
                      onClick={() => handleDelete(user.email, user.registeredUserId)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    ) : (
      <Card className="internalInvite">
        <Card.Body className="text-center">
          <p className="mb-3">No invited users yet.</p>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={handleRefresh}
            disabled={refreshing}
          >
            {refreshing ? (
              <>
                <Spinner size="sm" animation="border" className="me-1" />
                Refreshing...
              </>
            ) : (
              <>🔄 Refresh</>
            )}
          </Button>
        </Card.Body>
      </Card>
    )}
  </>
)}


{/* ✅ Organization Invites Tab Content (Admin Only) */}
{activeTab === "orgInvites" && isAdmin && (
  <>
    {loadingOrgInvites ? (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" role="status" />
        <p className="mt-2">Loading organization invites...</p>
      </div>
    ) : orgInvites.length > 0 ? (
      <Card className="InternalRefreshDiv">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">All Organization Invites</h5>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleRefresh}
              disabled={refreshing}
            >
              {refreshing ? (
                <>
                  <Spinner size="sm" animation="border" className="me-1" />
                  Refreshing...
                </>
              ) : (
                <>🔄 Refresh</>
              )}
            </Button>
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Invited By</th>
                <th>Department</th>
                <th>Contact Person</th>
                <th>Email</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {orgInvites.map((invite, idx) => (
                <tr key={idx}>
                  <td>
                    <strong>{invite.inviterName || "N/A"}</strong>
                    <br />
                    <small className="text-muted">{invite.inviterEmail}</small>
                  </td>
                  <td>{invite.departmentName}</td>
                  <td>{invite.contactPerson}</td>
                  <td>{invite.email}</td>
                  <td>
                    <span
                      className={`badge ${
                        invite.status === "Completed" ? "bg-success" : "bg-warning"
                      }`}
                    >
                      {invite.status}
                    </span>
                  </td>
                  <td>{new Date(invite.invitedAt || Date.now()).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    ) : (
      <Card className="internalInvite">
        <Card.Body className="text-center">
          <p className="mb-3">No organization invites found.</p>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={handleRefresh}
            disabled={refreshing}
          >
            {refreshing ? (
              <>
                <Spinner size="sm" animation="border" className="me-1" />
                Refreshing...
              </>
            ) : (
              <>🔄 Refresh</>
            )}
          </Button>
        </Card.Body>
      </Card>
    )}
  </>
)}


          {/* Import Modal for Module Responses */}
          <Modal show={showImportModal} onHide={() => setShowImportModal(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                📥 Import Module Responses from {selectedUser?.contactPerson} ({selectedUser?.email})
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {loadingUserData ? (
                <div className="text-center py-4">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2">Loading user module data...</p>
                </div>
              ) : (
                <Tabs defaultActiveKey="overview" className="mb-3">
                  <Tab eventKey="overview" title="Assessment Overview">
                    <div className="mb-4">
                      <h6 className="text-secondary mb-3">📊 User's Assessment Summary</h6>
                      {userAssessmentData ? (
                        <div className="row">
                          <div className="col-md-6">
                            <Card className="h-100">
                              <Card.Body>
                                <h6 className="card-title">Assessment Score</h6>
                                <h2 className="text-primary">{userAssessmentData.score || 0}%</h2>
                                <small className="text-muted">Overall security score</small>
                              </Card.Body>
                            </Card>
                          </div>
                          <div className="col-md-6">
                            <Card className="h-100">
                              <Card.Body>
                                <h6 className="card-title">AI Insights</h6>
                                <h2 className="text-info">{userAssessmentData.insights?.length || 0}</h2>
                                <small className="text-muted">Risk insights identified</small>
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      ) : (
                        <Alert variant="info">No assessment summary available for this user.</Alert>
                      )}
                    </div>
                  </Tab>
                  
                  <Tab eventKey="modules" title="Module Status">
                    <div className="mb-4">
                      <h6 className="text-secondary mb-3">📋 User's Module Completion Status</h6>
                      {userModuleData.moduleData && userModuleData.moduleData.filter(module => module.hasData).length > 0 ? (
                        <>
                          <div className="table-responsive">
                            <table className="table table-sm table-hover">
                              <thead className="table-light">
                                <tr>
                                  <th>Module Name</th>
                                  <th>Status</th>
                                  <th>Responses</th>
                                  <th>Completion</th>
                                  <th>Last Modified</th>
                                </tr>
                              </thead>
                              <tbody>
                                {userModuleData.moduleData
                                  .filter(module => module.hasData)
                                  .sort((a, b) => b.lastModified - a.lastModified)
                                  .map(module => (
                                  <tr key={module.moduleName}>
                                    <td>{module.displayName}</td>
                                    <td>
                                      <span className="badge bg-success">
                                        ✅ Completed
                                      </span>
                                    </td>
                                    <td>{module.responseCount} responses</td>
                                    <td>
                                      <div className="progress" style={{ height: '20px' }}>
                                        <div 
                                          className="progress-bar bg-success" 
                                          role="progressbar" 
                                          style={{ width: `${module.completionRate}%` }}
                                        >
                                          {module.completionRate}%
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      {module.lastModified ? 
                                        new Date(module.lastModified).toLocaleDateString() : 
                                        'N/A'
                                      }
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          
                          {/* Summary Statistics */}
                          <div className="row mt-3">
                            <div className="col-md-4">
                              <div className="text-center p-2 bg-success text-white rounded">
                                <strong>{userModuleData.moduleData.filter(m => m.hasData).length}</strong>
                                <br />
                                <small>Completed Modules</small>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="text-center p-2 bg-info text-white rounded">
                                <strong>{userModuleData.moduleData.reduce((sum, m) => sum + m.responseCount, 0)}</strong>
                                <br />
                                <small>Total Responses</small>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="text-center p-2 bg-warning text-dark rounded">
                                <strong>{Math.round(userModuleData.moduleData.filter(m => m.hasData).reduce((sum, m) => sum + m.completionRate, 0) / userModuleData.moduleData.filter(m => m.hasData).length || 0)}%</strong>
                                <br />
                                <small>Avg Completion</small>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="text-center py-4">
                          <Alert variant="warning">No completed modules found for this user.</Alert>
                        </div>
                      )}
                    </div>
                  </Tab>
                  
                  <Tab eventKey="import" title="Import Options">
                    <div className="mb-4">
                      <h6 className="text-secondary mb-3">Import Options</h6>
                      {availableModules.length > 0 ? (
                        <>
                          <div className="mb-3">
                            <Form.Check
                              type="radio"
                              id="import-all"
                              name="importMode"
                              label={`Import All Completed Modules (${availableModules.length} modules)`}
                              checked={importMode === 'all'}
                              onChange={() => setImportMode('all')}
                              className="mb-2"
                            />
                            <Form.Check
                              type="radio"
                              id="import-selective"
                              name="importMode"
                              label="Select Specific Modules"
                              checked={importMode === 'selective'}
                              onChange={() => setImportMode('selective')}
                            />
                          </div>

                          {/* Module Selection */}
                          {importMode === 'selective' && (
                            <div className="border rounded p-3 bg-light">
                              <h6 className="mb-3">Select Modules to Import:</h6>
                              <div className="row">
                                {availableModules.map(module => (
                                  <div key={module} className="col-md-6 col-lg-4 mb-2">
                                    <Form.Check
                                      type="checkbox"
                                      id={`module-${module}`}
                                      label={getCustomModuleName(module)}
                                      checked={selectedModules.includes(module)}
                                      onChange={(e) => handleModuleSelection(module, e.target.checked)}
                                    />
                                  </div>
                                ))}
                              </div>
                              <div className="internal-invite">
                                <small className="text-muted">
                                  Selected: {selectedModules.length} of {availableModules.length} modules
                                </small>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="text-center py-4">
                          <Alert variant="info">No modules available to import.</Alert>
                        </div>
                      )}
                    </div>
                  </Tab>
                </Tabs>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowImportModal(false)}>
                Cancel
              </Button>
              {userModuleData.moduleData && availableModules.length > 0 && (
                <Button
                  variant="primary"
                  onClick={handleImportModules}
                  disabled={importLoading || (importMode === 'selective' && selectedModules.length === 0)}
                >
                  {importLoading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Importing...
                    </>
                  ) : (
                    `Import ${importMode === 'all' ? 'All' : selectedModules.length} Module(s)`
                  )}
                </Button>
              )}
            </Modal.Footer>
          </Modal>
          {/* View Responses Modal */}
<Modal show={showResponsesModal} onHide={() => setShowResponsesModal(false)} size="xl">
  <Modal.Header closeButton>
    <Modal.Title>
      📋 Detailed Responses from {selectedUser?.contactPerson} ({selectedUser?.email})
    </Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
    {loadingUserData ? (
      <div className="text-center py-4">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading detailed responses...</p>
      </div>
    ) : selectedUserResponses.length > 0 ? (
      <>
        <div className="mb-3">
          <h6 className="text-secondary">
            📊 Total Responses: {selectedUserResponses.length}
          </h6>
        </div>
        
        {/* Group responses by module */}
        {Object.entries(
          selectedUserResponses.reduce((acc, response) => {
            if (!acc[response.moduleName]) {
              acc[response.moduleName] = [];
            }
            acc[response.moduleName].push(response);
            return acc;
          }, {})
        ).map(([moduleName, moduleResponses]) => (
          <div key={moduleName} className="mb-4">
            <h5 className="text-primary border-bottom pb-2">
              📦 {getCustomModuleName(moduleName)}
              <span className="badge bg-secondary ms-2">
                {moduleResponses.length} responses
              </span>
            </h5>
            
            <div className="table-responsive">
              <table className="table table-sm table-hover">
                <thead className="table-light">
                  <tr>
                    <th width="60%">Question</th>
                    <th width="15%">Answer</th>
                    <th width="25%">Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {moduleResponses.map((response, idx) => (
                    <tr key={idx}>
                      <td>
                        <small className="text-muted">Q{response.questionId}:</small>
                        <br />
                        {response.questionText}
                      </td>
                      <td>
                        <span 
                          className={`badge ${
                            response.answerText === 'Yes' ? 'bg-success' : 
                            response.answerText === 'No' ? 'bg-danger' : 
                            'bg-secondary'
                          }`}
                        >
                          {response.answerText}
                        </span>
                      </td>
                      <td>
                        <small className="text-muted">
                          {response.timestamp}
                        </small>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </>
    ) : (
      <div className="text-center py-4">
        <Alert variant="info">No detailed responses found for this user.</Alert>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowResponsesModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>
{/* Request Access Modal */}
<Modal show={showRequestModal} onHide={() => setShowRequestModal(false)} size="md">
  <Modal.Header closeButton>
    <Modal.Title>
      🔑 Request Dashboard Access
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {selectedRequestUser && (
      <>
        <div className="mb-3">
          <h6 className="text-secondary">Request access to:</h6>
          <p>
            <strong>{selectedRequestUser.contactPerson}</strong><br />
            <small className="text-muted">
              {selectedRequestUser.email} - {selectedRequestUser.departmentName}
            </small>
          </p>
        </div>
        
        <Alert variant="info" className="mb-3">
          <small>
            <strong>📋 You are requesting access to:</strong><br />
            • View their security assessment dashboard<br />
            • Import their AI-generated insights<br />
            • Import their detailed module responses<br />
            • View their question and answer details
          </small>
        </Alert>
        
        <Form.Group className="mb-3">
          <Form.Label>Reason for Access Request (Optional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="e.g., Need to review their security posture for compliance audit..."
            onChange={(e) => setRequestReason(e.target.value)}
          />
        </Form.Group>
        
        <Alert variant="warning">
          <small>
            <strong>⚠️ Note:</strong> The user will be notified of your request and can approve or deny access. 
            You'll only see the dashboard actions after they approve your request.
          </small>
        </Alert>
      </>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowRequestModal(false)}>
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={() => handleSubmitAccessRequest(requestReason)}
      disabled={requestLoading}
    >
      {requestLoading ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          Sending Request...
        </>
      ) : (
        "Send Access Request"
      )}
    </Button>
  </Modal.Footer>
</Modal>

{/* ✅ Template Management Modal */}
<Modal
  show={showTemplateManageModal}
  onHide={() => setShowTemplateManageModal(false)}
  size="lg"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>📋 Manage Invitation Templates</Modal.Title>
  </Modal.Header>
  
  <Modal.Body>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <p className="mb-0">Create, edit, or delete invitation templates</p>
      <Button
        variant="primary"
        size="sm"
        onClick={() => {
          setTemplateName("");
          setTempSelection([]);
          setShowTemplateManageModal(false);
          setShowCreateTemplateModal(true);
        }}
      >
        + Create New Template
      </Button>
    </div>

    {loadingTemplates ? (
      <div className="text-center py-4">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading templates...</p>
      </div>
    ) : templates.length > 0 ? (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Template Name</th>
            <th>Modules</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {templates.map((template) => (
            <tr key={template.templateId}>
              <td><strong>{template.templateName}</strong></td>
              <td>
                <small>{template.modules.length} modules</small>
              </td>
              <td>
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="me-2"
                  onClick={() => {
                    setEditingTemplate(template);
                    setTemplateName(template.templateName);
                    setTempSelection(template.modules);
                     setShowTemplateManageModal(false);
                    setShowEditTemplateModal(true);
                  }}
                >
                  ✏️ Edit
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => deleteTemplate(template.templateId, template.templateName)}
                >
                  🗑️ Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <Alert variant="info">
        No templates created yet. Click "Create New Template" to get started.
      </Alert>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowTemplateManageModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

{/* Continue with Create and Edit modals from your Sponsor component... */}
{/* ✅ Create Template Modal */}
<Modal
  show={showCreateTemplateModal}
  onHide={() => setShowCreateTemplateModal(false)}
  centered
  size="lg"
  dialogClassName="invite-modal-dialog"
>
  <Modal.Header closeButton className="invite-modal-header">
    <Modal.Title>Create New Template</Modal.Title>
  </Modal.Header>

  <Modal.Body className="invite-modal-body">
    <Form.Group className="mb-3">
      <Form.Label>Template Name *</Form.Label>
      <Form.Control
        type="text"
        placeholder="e.g., Standard Compliance, Security Audit, GDPR Package"
        value={templateName}
        onChange={(e) => setTemplateName(e.target.value)}
        required
      />
    </Form.Group>

      <p className="invite-modal-subtitle d-flex justify-content-between align-items-center">
  Select modules to include in this template:
 
  <Form.Control
    type="text"
    placeholder="Search modules..."
    value={moduleSearch}
    onChange={(e) => setModuleSearch(e.target.value)}
    style={{ width: "220px", marginRight: "44%" }}
  />
</p>
 
{/* Filter modules based on search */}
<div className="invite-modules-grid">
  {allModules
    .filter((m) =>
      m.toLowerCase().includes(moduleSearch.toLowerCase())
    )
    .map((m) => (
      <label
        key={m}
        className={
          "invite-module-card" +
          (tempSelection.includes(m)
            ? " invite-module-card-selected"
            : "")
        }
      >
        <input
          type="checkbox"
          checked={tempSelection.includes(m)}
          onChange={(e) =>
            handleTemplateChange(m, e.target.checked)
          }
        />
        <span className="invite-module-label">{m}</span>
      </label>
    ))}
</div>
  </Modal.Body>

  <Modal.Footer className="invite-modal-footer">
    <Button variant="secondary" onClick={() => setShowCreateTemplateModal(false)}>
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={saveTemplate}
      disabled={loading || !templateName.trim() || tempSelection.length === 0}
    >
      {loading ? (
        <>
          <Spinner size="sm" animation="border" className="me-1" />
          Updating...
        </>
      ) : (
         "💾 Create Template"
      )}
    </Button>
  </Modal.Footer>
</Modal>
{/* Edit Template Modal */}
<Modal
  show={showEditTemplateModal}
  onHide={() => {
    setShowEditTemplateModal(false);
    setEditingTemplate(null);
    setTemplateName("");
    setTempSelection([]);
  }}
  centered
  size="lg"
  dialogClassName="invite-modal-dialog"
>
  <Modal.Header closeButton className="invite-modal-header">
    <Modal.Title>Edit Template</Modal.Title>
  </Modal.Header>

  <Modal.Body className="invite-modal-body">
    <Form.Group className="mb-3">
      <Form.Label>Template Name *</Form.Label>
      <Form.Control
        type="text"
        placeholder="e.g., Standard Compliance, Security Audit, GDPR Package"
        value={templateName}
        onChange={(e) => setTemplateName(e.target.value)}
        required
      />
    </Form.Group>

    <p className="invite-modal-subtitle d-flex justify-content-between align-items-center">
      Select modules to include in this template:
      
      <Form.Control
        type="text"
        placeholder="Search modules..."
        value={moduleSearch}
        onChange={(e) => setModuleSearch(e.target.value)}
        style={{ width: "220px", marginRight: "44%" }}
      />
    </p>

    {/* Filter modules based on search */}
    <div className="invite-modules-grid">
      {allModules
        .filter((m) =>
          m.toLowerCase().includes(moduleSearch.toLowerCase())
        )
        .map((m) => (
          <label
            key={m}
            className={
              "invite-module-card" +
              (tempSelection.includes(m)
                ? " invite-module-card-selected"
                : "")
            }
          >
            <input
              type="checkbox"
              checked={tempSelection.includes(m)}
              onChange={(e) =>
                handleTemplateChange(m, e.target.checked)
              }
            />
            <span className="invite-module-label">{m}</span>
          </label>
        ))}
    </div>
  </Modal.Body>

  <Modal.Footer className="invite-modal-footer">
    <Button 
      variant="secondary" 
      onClick={() => {
        setShowEditTemplateModal(false);
        setEditingTemplate(null);
        setTemplateName("");
        setTempSelection([]);
      }}
    >
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={updateTemplate}
      disabled={loading || !templateName.trim() || tempSelection.length === 0}
    >
      {loading ? (
        <>
          <Spinner size="sm" animation="border" className="me-1" />
          Updating...
        </>
      ) : (
        "💾 Update Template"
      )}
    </Button>
  </Modal.Footer>
</Modal>


        </Col>
      </Row>
      <div className="px-4">
        <BackgroundFooter />
      </div>
    </>
  );
};

export default InternalInvite;
